/**
 * Format an extracted-fact ``value`` for the scalar preview row (#1498).
 *
 * Most facts are scalar strings. A classifier-v3 cell's repeating-row field — ``line_items`` (the
 * Buchungen on a bank statement) — arrives as a raw array of row objects. Stringifying that array
 * directly renders "[object Object],[object Object]"; instead we summarise the row count
 * (``"31 Positionen"``) until the dedicated repeating-row (Buchungen) table renderer lands.
 */
export function formatFactValue(value: string | unknown[] | null | undefined): string {
    if (Array.isArray(value)) {
        return value.length > 0 ? `${value.length} Positionen` : '';
    }
    return String(value ?? '');
}
